import angular from 'angular';

import BlurDirective, { selector } from './blur.directive';

export default angular
    .module('application.directive.blur', [])
    .directive(selector, BlurDirective);



// WEBPACK FOOTER //
// ./src/application/directive/blur/index.js